<script setup>
import Hero from "@/sections/about/Hero.vue";
import SplitImage from "@/sections/about/SplitImage.vue";
</script>

<template>
	<Hero title="About us" />

	<section>
		<div class="container">
			<p class="h4 lg:h3 font-primary">
				Every brand celebrates the athlete.
			</p>
			<p class="h3 lg:h2 font-primary mt-16">We celebrate the fan.</p>
		</div>
	</section>

	<SplitImage
		:images="[
			'https://ghostvision.s3.amazonaws.com/images/about/about1.jpg',
			'https://ghostvision.s3.amazonaws.com/images/about/about2.jpg',
		]"
	/>

	<section class="py-40 lg:py-80">
		<div class="container flex flex-col gap-24">
			<p class="h4 lg:h3 font-primary">For all the...</p>
			<p class="h3 lg:h1 font-primary-condensed">
				Obsessed, diehards, bleacher creatures<br />
				Unhinged, flaming table smashers<br />
				Junkies & nuts.
			</p>
			<p class="h4 lg:h3 font-primary">
				We built these sunglasses for you!
			</p>
		</div>
	</section>
</template>
